<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-input v-model="searchParam.keyword_search" placeholder="输入名称" clearable @clear="getList"></el-input>

        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="dialogVisible = true">新增 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="cat_id" label="序号" width="120px"> </el-table-column>
        <el-table-column prop="title" label="词库名" width="120px"> </el-table-column>

        <el-table-column prop="word_num" label="敏感词数" width="120px"> </el-table-column>
        <el-table-column prop="admin_name" label="创建人" width="160"></el-table-column>

        <el-table-column prop="update_time" label="最后修改时间" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">编辑</el-button>

            <el-button class="mid-blue" @click="toList(scope.row)">敏感词列表</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="ruleForm.cat_id ? '编辑敏感词库' : '新增敏感词库'"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :before-close="handleClose"
      >
        <el-input v-model="ruleForm.title"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="subForm">确 定</el-button>
        </span>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/mixins/pagination.js";
import { binaryList, binaryAdd, binaryEdit, binaryDel } from "@/api/analysis.js";
export default {
  mixins: [mixin],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {},
      loading: false,
      classList: [],
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    // this.getClassList('')
  },
  methods: {
    subForm() {
      if (!this.ruleForm.title) {
        this.$message.error("请输入词库名");
        return;
      }
      if (this.ruleForm.cat_id) {
        binaryEdit(this.ruleForm, this.ruleForm.cat_id).then((res) => {
          if (res == true) {
            this.$message.success("成功");
            this.getList();
            this.handleClose();
          }
        });
      } else {
        binaryAdd({ title: this.ruleForm.title }).then((res) => {
          if (res == true) {
            this.$message.success("成功");
            this.getList();
            this.handleClose();
          }
        });
      }
    },
    handleClose() {
      this.ruleForm = {};
      this.dialogVisible = false;
    },
    toList(item) {
      this.$router.push({
        path: "/word-list",
        query: item,
      });
    },
    getClassName(uuid) {
      const item = this.classList.find((it) => {
        return it.uuid == uuid;
      });
      if (item) {
        return item.title;
      }
    },
    async getClassList() {
      const res = await getCate({ status: 2 });
      if (res.data instanceof Array) {
        this.classList = res.data;
      }
    },
    toDetail(row) {
      this.ruleForm = { ...row };
      this.dialogVisible = true;
      console.log(row);
    },

    setTop(row) {
      setTopLive(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    xiajia(row) {
      GoodStatus(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    deleteItem(row) {
      this.$confirm("确定要删除该词库吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          binaryDel(row.cat_id).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await binaryList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
